/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {FieldConfig} from '../model/fieldConfig';
import {LandingPage} from '../model/landingPage';
import {LandingPageDTO} from '../model/landingPageDTO';
import {LandingPageHtmlDTO} from '../model/landingPageHtmlDTO';
import {LandingPageToken} from '../model/landingPageToken';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class ConfiguratorLandingPageService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Créer une nouvelle landing page
     * Cette requête permet de créer une nouvelle landing page.&lt;br&gt;Si la landing page est créée avec succès, le code 201 (Created) est renvoyé.&lt;br&gt;Si la landing page a déjà un identifiant, le code 400 (Bad Request) est renvoyé.
     * @param xDataStoreID X-DataStoreID
     * @param landingPageDTO landingPageDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createLandingPageUsingPOST(xDataStoreID: string, landingPageDTO: LandingPageDTO, observe?: 'body', reportProgress?: boolean): Observable<LandingPageDTO>;
    public createLandingPageUsingPOST(xDataStoreID: string, landingPageDTO: LandingPageDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LandingPageDTO>>;
    public createLandingPageUsingPOST(xDataStoreID: string, landingPageDTO: LandingPageDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LandingPageDTO>>;
    public createLandingPageUsingPOST(xDataStoreID: string, landingPageDTO: LandingPageDTO, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createLandingPageUsingPOST.');
        }

        if (landingPageDTO === null || landingPageDTO === undefined) {
            throw new Error('Required parameter landingPageDTO was null or undefined when calling createLandingPageUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<LandingPageDTO>(`${this.basePath}/api/landing-pages`,
            landingPageDTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Créer ou modifier un token
     * Cette requête permet de créer ou modifier un token d&#39;une landing page.&lt;br&gt;Le paramètre &#39;X_DATASTORE_ID&#39; est le code du datastore et ou le tenant.&lt;br&gt;Le paramètre &#39;landingPageCode&#39; est le code qui correspond à la landing page.
     * @param xDataStoreID X-DataStoreID
     * @param landingPageCode landingPageCode
     * @param email email
     * @param partner partner
     * @param tableId tableId
     * @param tableName tableName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createOrUpdateTokenUsingPOST(xDataStoreID: string, landingPageCode: string, email?: string, partner?: string, tableId?: string, tableName?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public createOrUpdateTokenUsingPOST(xDataStoreID: string, landingPageCode: string, email?: string, partner?: string, tableId?: string, tableName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public createOrUpdateTokenUsingPOST(xDataStoreID: string, landingPageCode: string, email?: string, partner?: string, tableId?: string, tableName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public createOrUpdateTokenUsingPOST(xDataStoreID: string, landingPageCode: string, email?: string, partner?: string, tableId?: string, tableName?: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createOrUpdateTokenUsingPOST.');
        }

        if (landingPageCode === null || landingPageCode === undefined) {
            throw new Error('Required parameter landingPageCode was null or undefined when calling createOrUpdateTokenUsingPOST.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (email !== undefined && email !== null) {
            queryParameters = queryParameters.set('email', <any>email);
        }
        if (landingPageCode !== undefined && landingPageCode !== null) {
            queryParameters = queryParameters.set('landingPageCode', <any>landingPageCode);
        }
        if (partner !== undefined && partner !== null) {
            queryParameters = queryParameters.set('partner', <any>partner);
        }
        if (tableId !== undefined && tableId !== null) {
            queryParameters = queryParameters.set('tableId', <any>tableId);
        }
        if (tableName !== undefined && tableName !== null) {
            queryParameters = queryParameters.set('tableName', <any>tableName);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<string>(`${this.basePath}/api/landing-pages/token`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Supprimer une landing page par son identifiant
     * Cette requête permet de supprimer une landing page par son identifiant.&lt;br&gt;Si la landing page est supprimée avec succès, le code 204 (NO_CONTENT) est renvoyé.
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteLandingPageUsingDELETE(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteLandingPageUsingDELETE(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteLandingPageUsingDELETE(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteLandingPageUsingDELETE(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling deleteLandingPageUsingDELETE.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteLandingPageUsingDELETE.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/landing-pages/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Supprimer un token
     * Cette requête permet de supprimer un token d&#39;une landing page.&lt;br&gt;Le paramètre &#39;X_DATASTORE_ID&#39; est le code du datastore et ou le tenant.&lt;br&gt;Le paramètre &#39;uuid&#39; est l&#39;identifiant du token à supprimer.
     * @param xDataStoreID X-DataStoreID
     * @param uuid uuid
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteTokenUsingDELETE(xDataStoreID: string, uuid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteTokenUsingDELETE(xDataStoreID: string, uuid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteTokenUsingDELETE(xDataStoreID: string, uuid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteTokenUsingDELETE(xDataStoreID: string, uuid: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling deleteTokenUsingDELETE.');
        }

        if (uuid === null || uuid === undefined) {
            throw new Error('Required parameter uuid was null or undefined when calling deleteTokenUsingDELETE.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.delete<any>(`${this.basePath}/api/landing-pages/token/${encodeURIComponent(String(uuid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dupliquer une landing page
     * Cette requête permet à un affilié destinataire de dupliquer une landing page partagée dans son propre périmètre. La copie a un nouveau propriétaire (l'affilié demandeur), un nouveau code et sa liste de partage est réinitialisée.
     * @param xDataStoreID X-DataStoreID
     * @param X_PARTNER_ID X-PARTNER-ID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public duplicateLandingPageUsingPOST(xDataStoreID: string, X_PARTNER_ID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<LandingPageDTO>;
    public duplicateLandingPageUsingPOST(xDataStoreID: string, X_PARTNER_ID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LandingPageDTO>>;
    public duplicateLandingPageUsingPOST(xDataStoreID: string, X_PARTNER_ID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LandingPageDTO>>;
    public duplicateLandingPageUsingPOST(xDataStoreID: string, X_PARTNER_ID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling duplicateLandingPageUsingPOST.');
        }

        if (X_PARTNER_ID === null || X_PARTNER_ID === undefined) {
            throw new Error('Required parameter X_PARTNER_ID was null or undefined when calling duplicateLandingPageUsingPOST.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling duplicateLandingPageUsingPOST.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
            queryParameters = queryParameters.set('X-PARTNER-ID', <any> X_PARTNER_ID);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<LandingPageDTO>(`${this.basePath}/api/landing-pages/${encodeURIComponent(String(id))}:duplicate`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister toutes les landing pages
     * Cette requête permet de lister toutes les landing pages.&lt;br&gt;Si la liste des landing pages est obtenue avec succès, le code 200 (OK) est renvoyé.
     * @param xDataStoreID X-DataStoreID
     * @param page Page number of the requested page
     * @param size Size of a page
     * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param idPart idPart
     * @param withoutHtml withoutHtml
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllLandingPagesUsingGET(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, idPart?: string, withoutHtml?: boolean, search?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<LandingPageDTO>>;
    public getAllLandingPagesUsingGET(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, idPart?: string, withoutHtml?: boolean, search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<LandingPageDTO>>>;
    public getAllLandingPagesUsingGET(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, idPart?: string, withoutHtml?: boolean, search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<LandingPageDTO>>>;
    public getAllLandingPagesUsingGET(xDataStoreID: string, page?: number, size?: number, sort?: Array<string>, idPart?: string, withoutHtml?: boolean, search?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllLandingPagesUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (search !== undefined && search !== null && search !== '') {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any> page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any> size);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('sort', <any> element);
            });
        }
        if (idPart !== undefined && idPart !== null) {
            queryParameters = queryParameters.set('idPart', <any> idPart);
        }
        if (withoutHtml !== undefined && withoutHtml !== null) {
            queryParameters = queryParameters.set('withoutHtml', <any> withoutHtml);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<LandingPageDTO>>(`${this.basePath}/api/landing-pages`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer les champs d&#39;une landing page par son code et langue
     * Cette requête permet de récupérer les champs d&#39;une landing page.&lt;br&gt;Si les champs de la landing page sont récupérés avec succès, le code 200 (OK) est renvoyé.&lt;br&gt;Si les champs de la landing page n&#39;ont pas été trouvé, le code 404 (Not Found) est renvoyé.&lt;br&gt;Le paramètre &#39;X_DATASTORE_ID&#39; est le code du datastore et ou le tenant.&lt;br&gt;Le paramètre &#39;code&#39; est le code qui correspond à la landing page.&lt;br&gt;Le paramètre &#39;lang&#39; est la langue de la landing page en ISO 639-1. Exemple : &#39;fr&#39; ou &#39;en&#39;.
     * @param xDataStoreID X-DataStoreID
     * @param code code
     * @param lang lang
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFieldsLandingPageByCodeUsingGET(xDataStoreID: string, code: string, lang: string, observe?: 'body', reportProgress?: boolean): Observable<Array<FieldConfig>>;
    public getFieldsLandingPageByCodeUsingGET(xDataStoreID: string, code: string, lang: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FieldConfig>>>;
    public getFieldsLandingPageByCodeUsingGET(xDataStoreID: string, code: string, lang: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FieldConfig>>>;
    public getFieldsLandingPageByCodeUsingGET(xDataStoreID: string, code: string, lang: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getFieldsLandingPageByCodeUsingGET.');
        }

        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling getFieldsLandingPageByCodeUsingGET.');
        }

        if (lang === null || lang === undefined) {
            throw new Error('Required parameter lang was null or undefined when calling getFieldsLandingPageByCodeUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<FieldConfig>>(`${this.basePath}/api/landing-pages/code/${encodeURIComponent(String(code))}/${encodeURIComponent(String(lang))}/fields`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer une landing page par son code et langue
     * Cette requête permet de récupérer une landing page par son code et par une langue.&lt;br&gt;Si la landing page est récupérée avec succès, le code 200 (OK) est renvoyé.&lt;br&gt;Si la landing page n&#39;est pas trouvée, le code 404 (Not Found) est renvoyé.&lt;br&gt;Le paramètre &#39;X_DATASTORE_ID&#39; est le code du datastore et ou le tenant.&lt;br&gt;Le paramètre &#39;code&#39; est le code qui correspond à la landing page.&lt;br&gt;Le paramètre &#39;lang&#39; est la langue de la landing page en ISO 639-1. Exemple : &#39;fr&#39; ou &#39;en&#39;.
     * @param xDataStoreID X-DataStoreID
     * @param code code
     * @param lang lang
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLandingPageByCodeUsingGET(xDataStoreID: string, code: string, lang: string, observe?: 'body', reportProgress?: boolean): Observable<LandingPage>;
    public getLandingPageByCodeUsingGET(xDataStoreID: string, code: string, lang: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LandingPage>>;
    public getLandingPageByCodeUsingGET(xDataStoreID: string, code: string, lang: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LandingPage>>;
    public getLandingPageByCodeUsingGET(xDataStoreID: string, code: string, lang: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getLandingPageByCodeUsingGET.');
        }

        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling getLandingPageByCodeUsingGET.');
        }

        if (lang === null || lang === undefined) {
            throw new Error('Required parameter lang was null or undefined when calling getLandingPageByCodeUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<LandingPage>(`${this.basePath}/api/landing-pages/code/${encodeURIComponent(String(code))}/${encodeURIComponent(String(lang))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer une landing page par son identifiant
     * Cette requête permet de récupérer une landing page par son identifiant.&lt;br&gt;Si la landing page est récupérée avec succès, le code 200 (OK) est renvoyé.&lt;br&gt;Si la landing page n&#39;est pas trouvée, le code 404 (Not Found) est renvoyé.
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLandingPageUsingGET(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<LandingPageDTO>;
    public getLandingPageUsingGET(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LandingPageDTO>>;
    public getLandingPageUsingGET(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LandingPageDTO>>;
    public getLandingPageUsingGET(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getLandingPageUsingGET.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getLandingPageUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<LandingPageDTO>(`${this.basePath}/api/landing-pages/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer une landing page par son code
     * Cette requête permet de récupérer une landing page par son code.&lt;br&gt;Le paramètre &#39;X_DATASTORE_ID&#39; est le code du datastore et ou le tenant.&lt;br&gt;Le paramètre &#39;code&#39; est le code qui correspond à la landing page.&lt;br&gt;Le paramètre &#39;token&#39; est un token qui permet de vérifier que l&#39;utilisateur est autorisé à récupérer la landing page.&lt;br&gt;Le paramètre &#39;lang&#39; est la langue de la landing page en ISO 639-1. Exemple : &#39;fr&#39; ou &#39;en&#39;.
     * @param xDataStoreID X-DataStoreID
     * @param code code
     * @param lang lang
     * @param token token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUsingGET(xDataStoreID: string, code: string, lang?: string, token?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getUsingGET(xDataStoreID: string, code: string, lang?: string, token?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getUsingGET(xDataStoreID: string, code: string, lang?: string, token?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getUsingGET(xDataStoreID: string, code: string, lang?: string, token?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getUsingGET.');
        }

        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling getUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (lang !== undefined && lang !== null) {
            queryParameters = queryParameters.set('lang', <any>lang);
        }
        if (token !== undefined && token !== null) {
            queryParameters = queryParameters.set('token', <any>token);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<LandingPageHtmlDTO>(`${this.basePath}/api/landingpage/${encodeURIComponent(String(code))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Renouveler un token
     * Cette requête permet de renouveler un token d&#39;une landing page.&lt;br&gt;Le paramètre &#39;X_DATASTORE_ID&#39; est le code du datastore et ou le tenant.&lt;br&gt;Le paramètre &#39;uuidToken&#39; est l&#39;identifiant du token à renouveler.
     * @param xDataStoreID X-DataStoreID
     * @param uuidToken uuidToken
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public renewalTokenUsingPOST(xDataStoreID: string, uuidToken: string, observe?: 'body', reportProgress?: boolean): Observable<LandingPageToken>;
    public renewalTokenUsingPOST(xDataStoreID: string, uuidToken: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LandingPageToken>>;
    public renewalTokenUsingPOST(xDataStoreID: string, uuidToken: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LandingPageToken>>;
    public renewalTokenUsingPOST(xDataStoreID: string, uuidToken: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling renewalTokenUsingPOST.');
        }

        if (uuidToken === null || uuidToken === undefined) {
            throw new Error('Required parameter uuidToken was null or undefined when calling renewalTokenUsingPOST.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (uuidToken !== undefined && uuidToken !== null) {
            queryParameters = queryParameters.set('uuidToken', <any> uuidToken);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<LandingPageToken>(`${this.basePath}/api/landing-pages/renewal-token`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mettre à jour les affiliés destinataires d'une landing page
     * Cette requête permet à un Tenant Admin de désigner les affiliés destinataires (accès en lecture seule) d'une landing page. Réservée au Tenant Admin du datastore.
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param affectedPartners affectedPartners
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateLandingPagePartnersUsingPUT(xDataStoreID: string, id: string, affectedPartners: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<LandingPageDTO>;
    public updateLandingPagePartnersUsingPUT(xDataStoreID: string, id: string, affectedPartners: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LandingPageDTO>>;
    public updateLandingPagePartnersUsingPUT(xDataStoreID: string, id: string, affectedPartners: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LandingPageDTO>>;
    public updateLandingPagePartnersUsingPUT(xDataStoreID: string, id: string, affectedPartners: Array<string>, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateLandingPagePartnersUsingPUT.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateLandingPagePartnersUsingPUT.');
        }

        if (affectedPartners === null || affectedPartners === undefined) {
            throw new Error('Required parameter affectedPartners was null or undefined when calling updateLandingPagePartnersUsingPUT.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<LandingPageDTO>(`${this.basePath}/api/landing-pages/${encodeURIComponent(String(id))}/partners`,
            affectedPartners,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mettre à jour une landing page
     * Cette requête permet de mettre à jour une landing page.&lt;br&gt;Si la landing page est mise à jour avec succès, le code 200 (OK) est renvoyé.&lt;br&gt;Si la landing page n&#39;est pas valide, le code 400 (Bad Request) est renvoyé.&lt;br&gt;Si la landing page n&#39;a pas pu être mise à jour, le code 500 (Internal Server Error) est renvoyé.
     * @param xDataStoreID X-DataStoreID
     * @param landingPageDTO landingPageDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateLandingPageUsingPUT(xDataStoreID: string, landingPageDTO: LandingPageDTO, observe?: 'body', reportProgress?: boolean): Observable<LandingPageDTO>;
    public updateLandingPageUsingPUT(xDataStoreID: string, landingPageDTO: LandingPageDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LandingPageDTO>>;
    public updateLandingPageUsingPUT(xDataStoreID: string, landingPageDTO: LandingPageDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LandingPageDTO>>;
    public updateLandingPageUsingPUT(xDataStoreID: string, landingPageDTO: LandingPageDTO, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateLandingPageUsingPUT.');
        }

        if (landingPageDTO === null || landingPageDTO === undefined) {
            throw new Error('Required parameter landingPageDTO was null or undefined when calling updateLandingPageUsingPUT.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<LandingPageDTO>(`${this.basePath}/api/landing-pages`,
            landingPageDTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
